import React, { useState } from 'react';
import Loading from 'components/Loading';
import Card from 'components/Card/CardNew';
import { scrollToFirstFormError } from '../../utils/scrollToFormError/scrollToFormError';
import { apiResponseWrapper } from 'utils/apiResponseWrapper';
import { mobilizationReport } from './MobilizationReportConfirmationService';
import MobilizationReportForm from './MobilizationReportForm';
import MobilizationReportConfirmation from './MobilizationReportConfirmation';
function Index() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  if (error) {
    return (
      <div className={'boo'}>
        <Card className={'mt-3 mb-3 p-3'}>
          <div>{error}</div>
        </Card>
      </div>
    );
  }

  if (isSubmitted) {
    return (
      <div className={'boo'}>
        <Card className={'mt-3 mb-3 p-3'}>
          <MobilizationReportConfirmation />
        </Card>
      </div>
    );
  }

  return (
    <div className={'boo'}>
      {isLoading && <Loading />}
      <MobilizationReportForm
        onSubmitFail={(e) => setTimeout(() => scrollToFirstFormError(e), 0)}
        onSubmit={async (values) => {
          const valuesForSubmit = new Map(values);

          valuesForSubmit.delete('inn');
          valuesForSubmit.delete('firstName');
          valuesForSubmit.delete('middleName');
          valuesForSubmit.delete('lastName');
          setIsLoading(true);
          try {
            const res = await mobilizationReport(Object.fromEntries(valuesForSubmit));
            apiResponseWrapper(res);
          } catch (error) {
            if (error.errorType) {
              setError(error.message);
            } else {
              setError(
                'Вы превысили лимит по количеству сообщений, направляемых в течение 24 часов.\nПожалуйста, повторите попытку позже.',
              );
            }
          } finally {
            setIsLoading(false);
            setIsSubmitted(true);
          }
        }}
      />
    </div>
  );
}

export default Index;
